import type { ReactNode } from 'react'
import { useInView } from 'react-intersection-observer'

interface LazyAnimationProps {
  children?: any
  className?: string
}

export function LazyAnimation(props: LazyAnimationProps): ReactNode {
  const { ref, inView } = useInView({
    triggerOnce: true,
    // rootMargin: "-150px 0px",
    rootMargin: '0px 0px',
  })

  return (
    <div ref={ref} className={`${props.className || ''} ${inView ? 'visible' : ''}`}>
      {props.children}
    </div>
  )
}
